import InputImport from "./Input";
import InfiniteInputImport from "./InfiniteInput";
import SelectionImport from "./Selection";

const mobileQR = {
  Input: InputImport,
  InfiniteInput: InfiniteInputImport,
  Selection: SelectionImport,
};

export const Input = InputImport;
export const InfiniteInput = InfiniteInputImport;
export const Selection = SelectionImport;
export default mobileQR;
